import styled from '@emotion/styled'
import { Modifiable, Mods } from '../../core/mods'

//TODO: Find a place for 'fake' components that isnt styles
export const ResetButton = styled.button<Mods>`
	all: inherit;
	flex-shrink: 0;
	${Modifiable}
`
